const t = {
  name: "Capital",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17 3H13V11H21V7C21 4.79086 19.2091 3 17 3ZM15 9V5H17C18.1046 5 19 5.89543 19 7V9H15Z" fill="currentColor"/>
<path d="M9 4H3V16C3 18.7614 5.23858 21 8 21H20V13H11V6C11 4.89543 10.1046 4 9 4ZM5 16V6H9V15H18V19H8C6.34315 19 5 17.6569 5 16Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Capital
};
